
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Classification } from '../../../models/classification.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-classification',
  template: `
    <kv-datatable
        *ngIf="activeView == 'list'"
        [allowsMultiSelection]="false"
        id="dt_classification"
        sectionTitle="{{ 'common.classification_title' | translate }}"
        listTitle="{{ 'common.list_title' | translate }}"
        [numRowsPerPage]="10"
        [titles]="titles"
        [items]="this.svc.list"
        deleteButton="{{ 'common.delete' | translate }}"
        editButton="{{ 'common.edit' | translate }}"
        addButton="{{ 'common.add' | translate }}"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onDelete)="delete($event)"
        (onCancelDetail)="this.svc.editing=null"
        [customButtons]="customButtons"
        (onCustomButton)="onCustomButton($event)"
        (onItemClick)="onItemClick($event)"

    >
      <app-classification-form
          *ngIf="this.svc.editing"
          [editingElement]="this.svc.editing"
          (onUpdateElement)="onUpdateElement($event)"
          (onAddElement)="onAddElement($event)"
      ></app-classification-form>
    </kv-datatable>
    <app-kv-classification-types
        *ngIf="activeView =='types'"
        (onBackClick)="reloadList()"
    ></app-kv-classification-types>
    <app-classification-details
        *ngIf="activeView == 'details'"
        (onBackClick)="reloadList()"
    ></app-classification-details>
  `
})
export class Classification2Component implements OnInit {

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  activeView = 'list';

  constructor(
    public svc: ClassificationService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {
      this.translate.get([
        'common.classification_parent',
        'common.certification_name',
        'common.classification_type',
        'common.classification_custom_types',
        'common.classification_custom_showdetail'
      ]).subscribe((res) => {
        console.log(res);
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'parent.name', label: res['common.classification_parent'] },
          { id: 'name', label: res['common.certification_name'] },
          { id: 'classification_type.name', label: res['common.classification_type'] },
        ];

        this.customButtons = [
          {
            isAlwaysEnabled: true,
            label: res['common.classification_custom_types'],
            callbackname: 'classification_types',
            icon: 'fa fa-detail'
          },
          {
            isAlwaysEnabled: false,
            label: res['common.classification_custom_showdetail'],
            callbackname: 'classification_detail',
            icon: 'fa fa-detail'
          }
        ]
      });
  }

  ngOnInit() {
    this.reloadList();
  }

  reloadList() {
    this.activeView = 'list';
    this.svc.getList().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.svc.editing = data == null ? new Classification() : data;
    console.log(this.svc.editing)
  }

  delete (entry): void {
    this.svc.delete(entry).subscribe();
  }

  onAddElement(entry): void {
    this.svc.post(entry).subscribe(() => {
      this.srvDataTable.get('dt_classification').showDetail = false;
      this.svc.editing = null;
    });
  }

  onUpdateElement(entry): void {
    this.svc.put(entry).subscribe(() => {
        this.srvDataTable.get('dt_classification').showDetail = false;
        this.svc.editing = null;
      }
    )
  }

  onCustomButton(event) {
    console.log(event)
    switch (event['callbackName']) {
      case 'classification_types':
        this.activeView = 'types';
        break;
      case 'classification_detail':
        this.activeView = 'details';
        break;
    }
  }

  onItemClick(entry) {
    this.svc.editing = entry;
    console.log(entry)
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification.component.ts